module.exports = __webpack_public_path__ + "img/summary_lg.d568a0b3.png";